<form
  *ngIf="(profileForm && (formReady$ | async) && (profile$ | async)) else loading"
  [formGroup]="profileForm"
  [class.compact-spacing]="fromDirectBooking"
  (submit)="submitForm()"
>
  <section data-test="general-header-text">
    @if (!fromDirectBooking) {
      <h2 class="iris-h2-responsive">Complete your account</h2>
      <p class="edit-profile-insurance-message iris-mb-04">
        We need a little more information so that you're all set for your first therapy session.
      </p>
    }
    <h3 class="iris-h3-responsive iris-mb-03">
      {{ accountInfoHeading }}
    </h3>
    <div class="form-body">
      @if (useFullForm && showPersonalGroup) {
        <iris-form-field
          label="Legal First Name"
          class="grid-col-6"
          data-test="first-name-header-text"
        >
          <iris-text-input
            required="true"
            formControlName="firstName"
            data-test="profile-first-name-input"
          ></iris-text-input>
        </iris-form-field>

        <iris-form-field
          label="Legal Last Name"
          class="grid-col-6"
          data-test="last-name-header-text"
        >
          <iris-text-input
            required="true"
            formControlName="lastName"
            data-test="profile-last-name-input"
          ></iris-text-input>
        </iris-form-field>

        <iris-form-field
          label="Preferred First Name"
          description="Enter the name you'd like your therapist to call you."
          class="grid-col-12"
          data-test="preferred-first-name-header-text"
        >
          <iris-text-input
            formControlName="preferredFirstName"
            data-test="profile-preferred-first-name-input"
          ></iris-text-input>
        </iris-form-field>
      }

      <iris-form-field
        [ngClass]="{'hidden-input' : !useFullForm || !showPersonalGroup}"
        label="Birthday"
        class="grid-col-6"
        data-test="birthday-header-text"
        required="true"
      >
        <iris-text-input
          *ngIf="!isMobile"
          formControlName="birthDate"
          type="date"
          required="true"
          [max]="$any(maxDate)"
          data-test="profile-birthday-input"
        ></iris-text-input>
        <iris-text-input
          *ngIf="isMobile"
          formControlName="birthDate"
          placeholder="mm/dd/yyyy"
          type="text"
          required="true"
          [mask]="masks.birthdayMask.ngxMask"
          [dropSpecialCharacters]="false"
          data-test="profile-birthday-input"
        ></iris-text-input>
      </iris-form-field>

      @if (useFullForm && showPersonalGroup && (formReady$ | async)) {
        <iris-form-field
          label="Gender"
          class="grid-col-6"
          data-test="gender-header-text"
        >
          <iris-dropdown
            required
            [formControlName]="'genderId'"
            [options]="genderOptions"
            data-test="dropdown-gender"
          >
          </iris-dropdown>
        </iris-form-field>
      }

      @if (saasInvited() && showContactGroup) {
        <iris-form-field
          data-test="country-header-text"
          [class]="'grid-col-12'"
          label="Country"
        >
          <iris-dropdown
            required="true"
            [options]="supportedCountryOptions"
            formControlName="mailingCountry"
            data-test="profile-country-input"
          >
          </iris-dropdown>
        </iris-form-field>
      }

      @if (showContactGroup) {
        <iris-form-field
          data-test="address-header-text"
          [class]="useInSessionRequest ? 'grid-col-12' : 'grid-col-8'"
          label="Address"
        >
          <iris-text-input
            required="true"
            id="pendo-address"
            formControlName="mailingAddressLine1"
            googleMapsAutoComplete
            (onAutoCompleteSelected)="onAddressSelected($event)"
            [autocompleteParams]="{ componentRestrictions: { country: 'us' }, types: ['address'] }"
            data-test="profile-mailing-address-input"
          >
          </iris-text-input>
        </iris-form-field>

        <iris-form-field
          [class]="useInSessionRequest ? 'grid-col-12' : 'grid-col-4'"
          label="Apt/Unit/Suite"
        >
          <iris-text-input
            formControlName="mailingAddressLine2"
            data-test="profile-mailing-address-line2-input"
          >
          </iris-text-input>
        </iris-form-field>

        <iris-form-field
          label="City"
          [class]="useInSessionRequest ? 'grid-col-12' : 'grid-col-5'"
          data-test="mailing-city-header-text"
        >
          <iris-text-input
            required="true"
            formControlName="mailingCity"
            data-test="profile-mailing-city-input"
          >
          </iris-text-input>
        </iris-form-field>

        <iris-form-field
          label="State"
          [class]="useInSessionRequest ? 'grid-col-12' : 'grid-col-4'"
          data-test="mailing-state-header-text"
        >
          <iris-dropdown
            required
            [formControlName]="'mailingState'"
            [options]="stateOptions()"
            data-test="profile-state-drop-down"
          >
          </iris-dropdown>
        </iris-form-field>

        <iris-form-field
          label="Zip code"
          [class]="useInSessionRequest ? 'grid-col-12' : 'grid-col-3'"
          data-test="mailing-postal-code-header-text"
        >
          <iris-text-input
            required="true"
            formControlName="mailingPostalCode"
            [mask]="zipcodeMask.ngxMask"
            data-test="profile-mailing-postal-code-input"></iris-text-input>
        </iris-form-field>

        <iris-form-field
          #addressFollowingField
          label="Phone Number"
          [class]="useFullForm ? 'grid-col-6' : 'grid-col-12'"
          data-test="phonenumber-header-text"
        >
          <iris-text-input
            required="true"
            type="tel"
            formControlName="phoneNumber"
            [mask]="phoneNumberMask.ngxMask"
            data-test="profile-phonenumber-input"
          >
          </iris-text-input>
        </iris-form-field>

        @if (useFullForm && (formReady$ | async)) {
          <iris-form-field
            label="Timezone"
            class="grid-col-6"
            data-test="timezone-header-text"
          >
            <iris-text-input
              required
              [formControlName]="'timeZone'"
              data-test="profile-timezone-drop-down"
            >
            </iris-text-input>
          </iris-form-field>
        }

        @if (!accountComplete && !skipAcknowledgeInfo) {
          <iris-form-field
            class="grid-col-12"
            [showOptionalTag]="false"
            [customErrorMessages]="{ required: 'Please confirm the above information is accurate to continue.' }"
          >
            <iris-checkbox
              formControlName="verification"
              data-test="checkbox-confirmation-text"
            >
              All of the above information is true, and accurate to the best of my knowledge.
            </iris-checkbox>
          </iris-form-field>
        }
      }

      <span *ngIf="!!error" class="profile-error grid-col-12" [innerHTML]="error"></span>
    </div>
  </section>

  @if (showContactGroup) {
    <section class="how-should-providers-contact-you">
      <h3 class="iris-mb-01">How should providers contact you?</h3>

      <iris-form-field
        [showOptionalTag]="false"
      >
        <div formGroupName="commPrefs">
          <iris-checkbox
            formControlName="commPrefsSms"
            data-test="quick-intake-form-sms-checkbox-text"
          >
            SMS text message (standard messaging rates apply)
          </iris-checkbox>
          <iris-checkbox
            formControlName="commPrefsPhone"
            data-test="quick-intake-form-phone-call-checkbox-text"
          >
            Phone call (they'll leave a voicemail if you aren't available)
          </iris-checkbox>
        </div>
      </iris-form-field>
    </section>
  }

  <section
    class="save-container"
    *ngIf="accountComplete"
  >
    <iris-button-container [alignment]="irisButtonContainerAlignments.END">
      <iris-button
        [type]="irisButtonTypes.PRIMARY"
        [typeAttribute]="irisButtonTypeAttributeOptions.SUBMIT"
        [disabled]="submitting || !profileForm.valid || profileForm.pristine"
        data-test="profile-save-button-text"
      >
        Save
      </iris-button>
    </iris-button-container>
  </section>
</form>

<ng-template #loading>
  @if (!fromDirectBooking) {
    <h2 class="iris-h2-responsive">Complete your account</h2>
  }
  <mat-spinner diameter="48" mode="indeterminate"></mat-spinner>
</ng-template>
